import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RefundStatus } from '../../enums/refund-status';
import { RefundStatusPipe } from '../../pipes';

@Component({
  selector: 'app-refund-status',
  imports: [CommonModule, RefundStatusPipe],
  templateUrl: './refund-status.component.html',
  styleUrl: './refund-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RefundStatusComponent {
  public readonly status = input.required<RefundStatus>();

  protected readonly cssClass = computed(() => {
    switch (this.status()) {
      case RefundStatus.Processed:
        return 'text-blue-600';

      case RefundStatus.Finalized:
        return 'text-green-600';

      case RefundStatus.Cancelled:
        return 'text-gray-500';

      default:
        return '';
    }
  });
}
